import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class c_wty_claim_defective_part extends entityBase {
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;
  good_will_transaction: KnockoutObservable<string>;
  good_will_transaction_reason: KnockoutObservable<string>;
  kdxx_unit_claim_status: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  part_serial_id: KnockoutObservable<string>;
  phenomenon_code: KnockoutObservable<string>;
  repl_part_id: KnockoutObservable<string>;
  repl_part_serial_id: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  request_unit_id: KnockoutObservable<string>;
  sequence: KnockoutObservable<number>;
  user_def1: KnockoutObservable<string>;
  disposal_check: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.created_by = ko.observable(item.created_by).extend({ maxLength: 50 });
    this.created_dttm = ko.observable(this.formatJSONDate(item.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.good_will_transaction = ko.observable(item.good_will_transaction).extend({ maxLength: 50 });
    this.good_will_transaction_reason = ko.observable(item.good_will_transaction_reason).extend({ maxLength: 50 });
    this.kdxx_unit_claim_status = ko.observable(item.kdxx_unit_claim_status);
    this.part_id = ko.observable(item.part_id).extend({ maxLength: 128 });
    this.part_serial_id = ko.observable(item.part_serial_id).extend({
      pattern: {
        message: "Placeholder(needed for future extensions)",
        params: "^.*$",
      },
    });
    this.phenomenon_code = ko.observable(item.phenomenon_code).extend({ maxLength: 128 });
    this.repl_part_id = ko.observable(item.repl_part_id);
    this.repl_part_serial_id = ko.observable(item.repl_part_serial_id).extend({
      pattern: {
        message: "Placeholder(needed for future extensions)",
        params: "^.*$",
      },
    });
    this.request_id = ko.observable(item.request_id).extend({ maxLength: 32 });
    this.request_unit_id = ko.observable(item.request_unit_id).extend({ maxLength: 32 });
    this.sequence = ko.observable(item.sequence);
    this.user_def1 = ko.observable(item.user_def1).extend({ maxLength: 256 });
    this.disposal_check = ko.observable(item.disposal_check).extend({ maxLength: 50 });
  }
}
